var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 131"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.30978 9.42612C2.18323 10.708 3.50421 12.0962 5.27273 13.5909C7.04124 12.0962 8.36223 10.708 9.23568 9.42612C10.1089 8.14455 10.5455 6.95827 10.5455 5.8673C10.5455 4.23096 10.0154 2.9274 8.95529 1.9566C7.89545 0.985532 6.66793 0.5 5.27273 0.5C3.87753 0.5 2.65001 0.985532 1.59016 1.9566C0.530054 2.9274 0 4.23096 0 5.8673C0 6.95827 0.436593 8.14455 1.30978 9.42612ZM5.27246 7.10547C6.10089 7.10547 6.77246 6.4339 6.77246 5.60547C6.77246 4.77704 6.10089 4.10547 5.27246 4.10547C4.44403 4.10547 3.77246 4.77704 3.77246 5.60547C3.77246 6.4339 4.44403 7.10547 5.27246 7.10547Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIcon);
export default __webpack_public_path__ + "static/media/map-icon.4edbd05ddd80dda2f6b3b1d42ce2950b.svg";
export { ForwardRef as ReactComponent };